module.exports = __webpack_public_path__ + "static/media/tennis.35c20c41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/tennis.svg
// module id = 401
// module chunks = 7